import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <section className="w-full bg-[#FBF8F3] px-5 py-14 sm:px-6 sm:py-20" data-id="element-152" data-mp="20m4qnvskykwl">
      <div className="mx-auto max-w-2xl" data-id="element-153" data-mp="24myc8iijvnmb">
        <div className="rounded-2xl border border-[#17808D]/25 bg-white p-6 sm:p-8" data-id="element-154" data-mp="24l3s36f3rzja">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#EEF6F7]" data-id="element-155" data-mp="29fhqlhp2ams6">
            <ShieldCheckIcon className="h-7 w-7 text-[#17808D]" aria-hidden="true" data-id="element-156" data-mp="2ecrqxsdzoius" />
          </span>
          <h2 className="mt-5 text-center font-display text-[1.6rem] font-bold leading-tight text-[#0E3B42] sm:text-[2.1rem]" data-id="element-157" data-mp="2obgz2tg32oxu">
            Il tuo investimento è completamente protetto
          </h2>

          <p className="mt-5 text-[14.5px] leading-relaxed text-[#3F5F64] sm:text-[15px]" data-id="element-158" data-mp="txg2kf80ae0x">
            Sappiamo che acquistare una risorsa digitale porta sempre a una
            domanda:{' '}
            <em className="font-display text-[16px] font-semibold italic text-[#0E3B42]" data-id="element-159" data-mp="3sl6jfs9h93sp">
              “E se non fosse quello che mi aspettavo?”
            </em>{' '}
            Per questo abbiamo eliminato il rischio.
          </p>

          <p className="mt-4 text-[14.5px] leading-relaxed text-[#3F5F64] sm:text-[15px]" data-id="element-160" data-mp="3iwojfd90v0q4">
            Hai <strong className="text-[#0E3B42]" data-id="element-161" data-mp="3dxlfjw4s30jq">7 giorni di garanzia</strong>.
            Se ritieni che il Percorso Clinico GLP-1 non porti maggiore chiarezza
            alle tue decisioni, non ti aiuti a risparmiare tempo durante le
            visite o non soddisfi le tue aspettative, ti basterà contattarci e ti
            rimborseremo il 100% del tuo denaro.
          </p>

          <p className="mt-5 rounded-xl bg-[#F3EDE3] p-3.5 text-center text-[11px] font-extrabold uppercase leading-relaxed tracking-[0.12em] text-[#8A6314]" data-id="element-162" data-mp="i5ndca9ogvz">
            Nessun modulo interminabile · Nessuna spiegazione imbarazzante ·
            Nessun rischio per te
          </p>
        </div>

        <CTAButton className="mt-9" label="Prova senza rischi per 7 giorni" subline="Se non fa per te, ti restituiamo il 100%" data-id="element-163" data-mp="1d7wdn27uu0l6" />
      </div>
    </section>;
}